import { render, staticRenderFns } from "./ServersVpnManage.vue?vue&type=template&id=09184a86"
import script from "./ServersVpnManage.vue?vue&type=script&lang=js"
export * from "./ServersVpnManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports